const terms = [3, 6, 12, 18, 24, 36, 48, 60];

import { updateQuoteBoost } from './form/quoteboost';

/**
 * 
 * @param {number} amount 
 * @return {array} allowed terms
 */
export function getAllowedTerms(amount) {
    if (amount < 1000) {
        return [3, 6, 12];
    } else if (amount == 1000) {
        return [3, 6, 12, 18, 24, 36];
    } else if (amount > 1000 && amount <= 2000) {
        return [6, 12, 18, 24, 36];
    } else if (amount >= 2000 && amount <= 2500) {
        return [6, 12, 18, 24, 36];
    } else if (amount > 2500 && amount <= 7500) {
        return [12, 18, 24, 36, 48, 60];
    } else if (amount >= 7500 && amount <= 10000) {
        return [18, 24, 36, 48, 60];
    } else {
        return [12, 18, 24, 36, 48, 60];
    }
    return [3, 6, 12, 18, 24, 36, 48, 60];
}

export function setupAmountTermLockout(amountInput, termInput) {


    let changeHandler = () => {
        let amount = amountInput.val();
        let roundedAmount = roundLoanAmount(amount);
        if (amount != roundedAmount) {
            amountInput.val(roundedAmount).change();
            return false;
        }
        let term = termInput.val();
        let allowedTerms = getAllowedTerms(amount);
        if (!allowedTerms.includes(parseInt(term, 10))) {
            if (term == '' || term < allowedTerms[0]) {
                term = allowedTerms[0];
                termInput.val(term);
            } else {
                term = allowedTerms[allowedTerms.length - 1];
                termInput.val(term);
            }
        }
        // Loop through the options and set them to disabled or enabled
        let options = termInput.find('option');
        options.each(function (i, o) {
            if (allowedTerms.includes(parseInt(o.value, 10))) {
                // Should be enabled
                o.disabled = false;
            } else {
                // Should be disabled
                o.disabled = true;
            }
        });

        // Uopdate other loan amount boxes
        $('[name=loan_amount]').not(amountInput).val(roundedAmount);
        $('.loan_amount').text(roundedAmount);
        $('.loan_amount_formatted').text(formatCurrency(roundedAmount));
        $('.loan_term').text(term);
        updateQuoteBoost();
    };
    amountInput.change(changeHandler);
    termInput.change(changeHandler);
    // Sort it out on load
    changeHandler();
}

/**
 * Round down to the nearest 50 and set min and max
 * 
 * @param {number} amount amount as number
 * @return {number} rounded and normalized amount
 */
export function roundLoanAmount(amount) {

    return Math.max(LOAN_AMOUNT_MIN, Math.min(LOAN_AMOUNT_MAX, Math.floor(amount / 50) * 50));
}

/**
 * 
 * @param {number} amount Amount to format
 */
export function formatCurrency(amount) {
    return parseInt(amount, 10).toLocaleString('en');
}